module.exports = __webpack_public_path__ + "img/dy_p6_img_1.efcee96a.png";